/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */

// The following polyfills are needed for IE11

import { ApiVersion } from '@tableau/api-shared-js';
import 'core-js/es/array/find';
import 'core-js/es/array/from';
import 'core-js/es/map';
import 'core-js/es/number/is-integer';
import 'core-js/es/number/is-nan';
import 'core-js/es/number/parse-float';
import 'core-js/es/number/parse-int';
import 'core-js/es/object/assign';
import 'core-js/es/object/entries';
import 'core-js/es/object/set-prototype-of';
import 'core-js/es/promise';
// Due to the way we configured webpack, we should be exporting things which will be under
// a global variable called "tableau". Export everything we want to be visible under tableau
// from this file.
import { ExtensionsImpl } from './ExtensionsApi/Impl/ExtensionsImpl';
import { Extensions } from './ExtensionsApi/Namespaces/Extensions';

declare let VERSION_IS_ALPHA: boolean;
const isAlpha: boolean = typeof VERSION_IS_ALPHA !== 'undefined' ? VERSION_IS_ALPHA : false;

declare let API_VERSION_NUMBER: string;
ApiVersion.SetVersionNumber(typeof API_VERSION_NUMBER !== 'undefined' ? API_VERSION_NUMBER : '0.0.0', isAlpha);

const extensionImpl = new ExtensionsImpl();
export const extensions = new Extensions(extensionImpl);

// Export Enums
// These show up under the tableau object. I.e. tableau.ExtensionContext.Server
export {
  AnalyticsObjectType,
  AnnotationType,
  ClassNameKey,
  ColumnType,
  DashboardLayoutChange,
  DashboardObjectType,
  DashboardObjectVisibilityType,
  DataType,
  DateRangeType,
  DialogStyle,
  EncodingType,
  ErrorCodes,
  ExtensionContext,
  ExtensionMode,
  FieldAggregationType,
  FieldRoleType,
  FilterDomainType,
  FilterNullOption,
  FilterType,
  FilterUpdateType,
  HierarchicalLevelSelectionState,
  IncludeDataValuesOption,
  MarkType,
  ParameterValueType,
  PeriodType,
  QuickTableCalcType,
  RelativeDateFilterOptions,
  ReplaySpeedType,
  SelectOptions,
  SelectionUpdateType,
  SheetType,
  SortDirection,
  TableauEventType,
  TrendLineModelType,
  VizImageEncodingType,
  VizImagePaletteType,
  VizImageSizeSettingAlignmentType,
  VizImageSizeSettingType,
  VizImageSortDirectionType,
  ZoneVisibilityType,
} from '@tableau/api-external-contract-js';
